export default "__VITE_ASSET__4FXUUZod__"